import React, { useState, useRef, useEffect } from 'react';

const Rsvp = () => {
  // Stati per gestire i dati del form
  const [name, setName] = useState('');
  const [attendance, setAttendance] = useState('');
  const [participants, setParticipants] = useState('');
  const [participantNames, setParticipantNames] = useState(['']); // NUOVO: array dei nomi degli invitati
  const [children, setChildren] = useState('0');
  const [participantMenuChoices, setParticipantMenuChoices] = useState([]); // NUOVO: array delle scelte menu individuali
  const [allergiesByParticipant, setAllergiesByParticipant] = useState([]); // MODIFICATO: allergie per partecipante
  const [message, setMessage] = useState('');
  const [transportation, setTransportation] = useState('');
  
  // Stati per controllare l'interfaccia
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeParticipantTab, setActiveParticipantTab] = useState(0); // NUOVO: tab attivo per i partecipanti
  const [visitedParticipants, setVisitedParticipants] = useState([0]); // NUOVO: partecipanti visitati (inizia con il primo)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(false);
  
  // Riferimento al reCAPTCHA
  const recaptchaRef = useRef(null);

  // NUOVO Effetto per aggiornare participantNames quando cambia participants
  useEffect(() => {
    const numParticipants = parseInt(participants) || 1;
    setParticipantNames(prevNames => {
      const newNames = [...prevNames];
      if (newNames.length < numParticipants) {
        // Aggiungi nomi vuoti se aumenta il numero di partecipanti
        while (newNames.length < numParticipants) {
          newNames.push('');
        }
      } else if (newNames.length > numParticipants) {
        // Rimuovi nomi in eccesso se diminuisce il numero di partecipanti
        newNames.splice(numParticipants);
      }
      // Il primo nome è sempre quello del compilatore del form
      if (newNames.length > 0 && name.trim()) {
        newNames[0] = name.trim();
      }
      return newNames;
    });
    
    // Reset del tab attivo se supera il numero di partecipanti
    setActiveParticipantTab(prevTab => {
      if (prevTab >= numParticipants) {
        return Math.max(0, numParticipants - 1);
      }
      return prevTab;
    });
    
    // Reset dei partecipanti visitati quando cambia il numero
    setVisitedParticipants([0]); // Sempre inizia con il primo partecipante visitato
  }, [participants, name]);

  // NUOVO Effetto per aggiornare participantMenuChoices quando cambia participants
  useEffect(() => {
    const numParticipants = parseInt(participants) || 1;
    setParticipantMenuChoices(prevChoices => {
      const newChoices = [...prevChoices];
      if (newChoices.length < numParticipants) {
        // Aggiungi scelte vuote se aumenta il numero di partecipanti
        while (newChoices.length < numParticipants) {
          newChoices.push('pesce'); // Default a pesce (raccomandato dagli sposi)
        }
      } else if (newChoices.length > numParticipants) {
        // Rimuovi scelte in eccesso se diminuisce il numero di partecipanti
        newChoices.splice(numParticipants);
      }
      return newChoices;
    });
  }, [participants]);

  // NUOVO Effetto per aggiornare allergiesByParticipant quando cambia participants
  useEffect(() => {
    const numParticipants = parseInt(participants) || 1;
    setAllergiesByParticipant(prevAllergies => {
      const newAllergies = [...prevAllergies];
      if (newAllergies.length < numParticipants) {
        // Aggiungi allergie vuote se aumenta il numero di partecipanti
        while (newAllergies.length < numParticipants) {
          newAllergies.push('');
        }
      } else if (newAllergies.length > numParticipants) {
        // Rimuovi allergie in eccesso se diminuisce il numero di partecipanti
        newAllergies.splice(numParticipants);
      }
      return newAllergies;
    });
  }, [participants]);

  // Vai alla slide successiva
  const nextSlide = () => {
    setCurrentSlide(prev => prev + 1);
    // Scroll al top della slide in modalità mobile per tutti gli step
    setTimeout(() => {
      const rsvpCard = document.querySelector('.rsvp-card');
      if (rsvpCard) {
        rsvpCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  // Vai alla slide precedente
  const prevSlide = () => {
    setCurrentSlide(prev => prev - 1);
    // Scroll al top della slide in modalità mobile
    setTimeout(() => {
      const rsvpCard = document.querySelector('.rsvp-card');
      if (rsvpCard) {
        rsvpCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };
  
  // Validazione per slide - Updated to include participant names validation
  const validateCurrentSlide = () => {
    switch(currentSlide) {
      case 0: // Nome e partecipazione
        return name.trim() !== '' && attendance !== '';
      case 1: // Numero partecipanti
        return attendance !== 'Si' || (participants !== '' && parseInt(participants) > 0);
      case 2: // Nomi partecipanti (NUOVO)
        if (attendance !== 'Si') return true;
        const numParticipants = parseInt(participants) || 1;
        return participantNames.length === numParticipants && 
               participantNames.every(name => name.trim() !== '');
      case 3: // Scelte menu individuali
        if (attendance !== 'Si') return true;
        return participantMenuChoices.length === (parseInt(participants) || 1) &&
               participantMenuChoices.every(choice => ['pesce', 'carne', 'vegetariano'].includes(choice));
      default:
        return true;
    }
  };

  // NUOVA FUNZIONE: Gestisce il cambio di nome per un partecipante
  const handleParticipantNameChange = (index, value) => {
    setParticipantNames(prev => {
      const updated = [...prev];
      if (index >= 0 && index < updated.length) {
        updated[index] = value;
      }
      return updated;
    });
  };

  // NUOVA FUNZIONE: Gestisce il cambio di scelta menu per un partecipante
  const handleParticipantMenuChange = (index, menuChoice) => {
    setParticipantMenuChoices(prev => {
      const updated = [...prev];
      if (index >= 0 && index < updated.length) {
        updated[index] = menuChoice;
      }
      return updated;
    });
  };
  
  // NUOVA FUNZIONE: Gestisce il cambio di allergia per un partecipante
  const handleParticipantAllergyChange = (index, value) => {
    setAllergiesByParticipant(prev => {
        const updated = [...prev];
        if (index >= 0 && index < updated.length) {
            updated[index] = value;
        }
        return updated;
    });
  };

  // NUOVA FUNZIONE: Naviga al tab successivo dei partecipanti
  const nextParticipantTab = () => {
    const numParticipants = parseInt(participants) || 1;
    if (activeParticipantTab < numParticipants - 1) {
      const nextTab = activeParticipantTab + 1;
      setActiveParticipantTab(nextTab);
      
      // Aggiungi il partecipante alla lista dei visitati se non c'è già
      setVisitedParticipants(prev => {
        if (!prev.includes(nextTab)) {
          return [...prev, nextTab];
        }
        return prev;
      });
      
      // Scroll all'inizio del form quando si naviga tra i partecipanti
      setTimeout(() => {
        const rsvpCard = document.querySelector('.rsvp-card');
        if (rsvpCard) {
          rsvpCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  // NUOVA FUNZIONE: Naviga al tab precedente dei partecipanti
  const prevParticipantTab = () => {
    if (activeParticipantTab > 0) {
      const prevTab = activeParticipantTab - 1;
      setActiveParticipantTab(prevTab);
      
      // Il partecipante precedente dovrebbe già essere nella lista dei visitati
      // Ma aggiungiamolo per sicurezza
      setVisitedParticipants(prev => {
        if (!prev.includes(prevTab)) {
          return [...prev, prevTab];
        }
        return prev;
      });
      
      // Scroll all'inizio del form quando si naviga tra i partecipanti
      setTimeout(() => {
        const rsvpCard = document.querySelector('.rsvp-card');
        if (rsvpCard) {
          rsvpCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  // AGGIORNATA: Verifica se tutti i partecipanti hanno completato menu E sono stati visitati
  const isAllParticipantDataComplete = () => {
    const numParticipants = parseInt(participants) || 1;
    const allDataComplete = participantMenuChoices.length === numParticipants &&
           participantMenuChoices.every(choice => ['pesce', 'carne', 'vegetariano'].includes(choice));
    
    const allVisited = visitedParticipants.length === numParticipants;
    
    return allDataComplete && allVisited;
  };

  // NUOVA FUNZIONE: Verifica se il partecipante corrente ha completato i dati
  const isCurrentParticipantComplete = () => {
    return participantMenuChoices[activeParticipantTab] && 
           ['pesce', 'carne', 'vegetariano'].includes(participantMenuChoices[activeParticipantTab]);
  };

  // NUOVA FUNZIONE: Gestisce il click diretto su un tab (con limitazioni)
  const handleTabClick = (index) => {
    // Permetti di cliccare solo sui tab già visitati o quello immediatamente successivo
    const canAccess = visitedParticipants.includes(index) || 
                      (index === Math.max(...visitedParticipants) + 1 && index < parseInt(participants));
    
    if (canAccess) {
      setActiveParticipantTab(index);
      if (!visitedParticipants.includes(index)) {
        setVisitedParticipants(prev => [...prev, index]);
      }
      
      // Scroll all'inizio del form quando si naviga tra i partecipanti
      setTimeout(() => {
        const rsvpCard = document.querySelector('.rsvp-card');
        if (rsvpCard) {
          rsvpCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  // Gestione del submit del form
  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    setRecaptchaError(false);
    
    try {
      // Verifica reCAPTCHA v3
      // @ts-ignore
      window.grecaptcha.ready(() => {
        // @ts-ignore
        window.grecaptcha.execute('6LfCNu4qAAAAABjNGmzL9-Hdi_eZWEJCb904H2-6', {action: 'submit'})
          .then(recaptchaValue => {
            if (!recaptchaValue) {
              setRecaptchaError(true);
              setIsSubmitting(false);
              return;
            }
            
            // URL del Google Apps Script Web App 
            const scriptURL = "https://script.google.com/macros/s/AKfycbxuKBl6VUT4bsjRlftvCNeBfitfnLm6VfGy3DxdlU7pqKwAGmOn2b6ib8rCSMFjF0U2/exec"            
            // Conteggio dei menu per compatibilità con il backend esistente
            const menuCounts = participantMenuChoices.reduce((counts, choice) => {
              counts[choice] = (counts[choice] || 0) + 1;
              return counts;
            }, { pesce: 0, carne: 0, vegetariano: 0 });

            // Prepara i dati
            const formData = {
              name,
              attendance,
              participants,
              participantNames: participantNames.join('|'), // Nomi degli invitati separati da |
              participantMenuChoices: participantMenuChoices.join('|'), // NUOVO: scelte menu individuali
              children,
              menuPesce: menuCounts.pesce, // Per compatibilità backend
              menuCarne: menuCounts.carne, // Per compatibilità backend
              menuVegetariano: menuCounts.vegetariano, // Per compatibilità backend
              allergiesByParticipant: allergiesByParticipant.join('|'), // NUOVO: allergie per partecipante
              message,
              transportation,
              recaptchaToken: recaptchaValue
            };
                        
            // Crea un iframe nascosto
            const iframe = document.createElement('iframe');
            iframe.name = 'hidden_iframe';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            
            // Crea un form temporaneo
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = scriptURL;
            form.target = 'hidden_iframe';
            
            // Aggiungi input nascosti con i singoli campi
            Object.entries(formData).forEach(([key, value]) => {
              if (key !== 'recaptchaToken') { // Escludiamo il token recaptcha dai parametri individuali
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value || ''; // Assicuriamoci che non ci siano valori null o undefined
                form.appendChild(input);
              }
            });
            
            // Aggiungi il token reCAPTCHA
            const recaptchaInput = document.createElement('input');
            recaptchaInput.type = 'hidden';
            recaptchaInput.name = 'recaptchaToken';
            recaptchaInput.value = recaptchaValue;
            form.appendChild(recaptchaInput);
            
            document.body.appendChild(form);
            form.submit();
            
            setTimeout(() => {
              document.body.removeChild(form);
              document.body.removeChild(iframe);
              setSubmitStatus('success');
              setCurrentSlide(0);
              setActiveParticipantTab(0); // Reset del tab attivo
              setVisitedParticipants([0]); // NUOVO: reset dei partecipanti visitati
              setName('');
              setAttendance('');
              setParticipants('1'); // Questo triggererà l'useEffect per menuCounts
              setParticipantNames(['']); // Reset dei nomi partecipanti
              setParticipantMenuChoices([]); // Reset delle scelte menu
              setAllergiesByParticipant([]); // Reset delle allergie
              setChildren('0');
              setMessage('');
              setTransportation('');
              setIsSubmitting(false);
            }, 2000);
          });
      });
      
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
      setIsSubmitting(false);
    }
  };

  // Indicatore di progresso
  const renderProgressIndicator = () => {
    const totalSlides = attendance === 'Si' ? 5 : 2;
    const dots = [];
    
    for (let i = 0; i < totalSlides; i++) {
      dots.push(
        <span 
          key={i} 
          className={`progress-dot ${currentSlide === i ? 'active' : ''}`}
          onClick={() => {
            if (i < currentSlide) {
              setCurrentSlide(i);
              // Scroll al top della slide in modalità mobile
              setTimeout(() => {
                const rsvpCard = document.querySelector('.rsvp-card');
                if (rsvpCard) {
                  rsvpCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }, 100);
            }
          }}
        />
      );
    }
    
    return (
      <div className="progress-indicator">
        {dots}
      </div>
    );
  };

  return (
    <section id="rsvp">
        <span className="line"></span> {/* Linea separatrice */}
        <div id="rsvp" className="story-section">
            <h2 className="story-title font-detail">RSVP</h2>   
            <p className="font-detail rsvp-deadline">Vi preghiamo gentilmente di confermare la vostra presenza entro il <strong className='uppercase'>31 Luglio 2025</strong></p>
            <div className="rsvp-card">
                {renderProgressIndicator()}
                
                {/* Moved Success Message */}
                {submitStatus === 'success' && (
                    <div className="success-message card-message">
                        Grazie per la tua risposta!
                    </div>
                )}
                {/* Moved Error Message */}
                {submitStatus === 'error' && (
                    <div className="error-message card-message">
                    Si è verificato un errore durante l'invio. Per favore, contattaci direttamente.
                    </div>
                )}
                {/* Moved Recaptcha Error Message */}
                {recaptchaError && (
                    <div className="error-message card-message" style={{ marginTop: '10px' }}>
                    Errore di verifica reCAPTCHA. Ricarica la pagina e riprova.
                    </div>
                )}
                
                {/* reCAPTCHA Container */}
                <div className="recaptcha-container" ref={recaptchaRef}></div>

                <div className="slide-container">
                    <div className="slides-wrapper">
                        {/* Slide 1: Nome e Partecipazione - Always visible when currentSlide is 0 */}
                        {currentSlide === 0 && (
                            <div className="form-slide">
                                <h5 className='confirm font-detail'>
                                    Parteciperai al nostro matrimonio?
                                </h5>
                                <div className="slide-content">
                                    <p className="font-detail text-confirm slide-paragraph">
                                        <strong>Nota bene:</strong> Compila questo form per te e per il tuo gruppo/famiglia
                                    </p>
                                    <p className="font-detail text-confirm slide-paragraph">Inizia inserendo il tuo nome e cognome</p>
                                    <input 
                                        id="name"
                                        type="text" 
                                        placeholder="Il tuo Nome e Cognome" 
                                        required 
                                        value={name} 
                                        onChange={(e) => setName(e.target.value)} 
                                    />
                                    {/*<p className="font-detail text-confirm slide-paragraph">Parteciperai al nostro matrimonio?</p>*/}
                                    <div className="checkbox-group">
                                        <div className="checkbox-item font-detail">
                                            <input type="radio" name="attendance" id="si" value="Si" checked={attendance === 'Si'}
                                                onChange={() => { setAttendance('Si'); if (!participants) setParticipants('1'); }}
                                            />
                                            <label htmlFor="si">Sì, parteciperò con piacere</label>
                                        </div>
                                        <div className="checkbox-item font-detail">
                                            <input type="radio" name="attendance" id="no" value="No" checked={attendance === 'No'} onChange={() => setAttendance('No')}/>
                                            <label htmlFor="no">Purtroppo non potrò partecipare</label>
                                        </div>
                                        <div className="checkbox-item font-detail">
                                            <input type="radio" name="attendance" id="maybe" value="Forse" checked={attendance === 'Forse'} onChange={() => setAttendance('Forse')}/>
                                            <label htmlFor="maybe">Vi farò sapere più avanti</label>
                                        </div>
                                    </div>
                                    <div className="slide-buttons single-button-center">
                                        <button type="button" onClick={nextSlide} disabled={!validateCurrentSlide()} className="slide-button next-button">
                                            AVANTI
                                        </button>
                                    </div> 
                                </div>
                            </div>
                        )}

                        {/* Slide 2: Conditional based on attendance */}
                        {currentSlide === 1 && (attendance === 'No' || attendance === 'Forse') && (
                            <div className="form-slide">
                                <h5 className='confirm font-detail'>
                                    {attendance === 'No' ? 'Ci dispiace che non potrai partecipare' : 'Grazie per averci informato'}
                                </h5>
                                <div className="slide-content">
                                    <textarea
                                        placeholder="Se vuoi, lasciaci un messaggio."
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        rows={4}
                                        className="text-area-input"
                                    />
                                    <div className="slide-buttons">
                                        <button type="button" onClick={prevSlide} className="slide-button prev-button">
                                        INDIETRO
                                        </button>
                                        <button type="button" onClick={handleSubmit} className="slide-button submit-button" disabled={isSubmitting}>
                                            {isSubmitting ? 'INVIO...' : 'INVIA'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Slide 2: Participants (if attending) */}
                        {currentSlide === 1 && attendance === 'Si' && (
                            <div className="form-slide">
                                <h5 className='confirm font-detail'>
                                    Quante persone parteciperanno?
                                </h5>
                                <div className="slide-content">
                                    <p className="font-detail text-confirm slide-paragraph">
                                        Indica il numero totale di persone del tuo gruppo (incluso te)
                                    </p>
                                    <div className="participants-group">
                                        <div className="counter-container">
                                            <div className="counter-text-container">
                                                <p className="font-detail text-confirm slide-paragraph">Invitati totali</p>
                                                <p className="font-detail text-confirm slide-paragraph">(incluso te)</p>
                                            </div>
                                            <div className="counter-controls">
                                                <button type="button" className="counter-button" onClick={() => { const c = parseInt(participants) || 1; if (c > 1) setParticipants((c - 1).toString()); }} disabled={parseInt(participants) <= 1} aria-label="Diminuisci"><span className="counter-icon">−</span></button>
                                                <span className="counter-value">{participants || 1}</span>
                                                <button type="button" className="counter-button" onClick={() => { const c = parseInt(participants) || 1; if (c < 20) setParticipants((c + 1).toString()); }} disabled={parseInt(participants) >= 20} aria-label="Aumenta"><span className="counter-icon">+</span></button>
                                            </div>
                                        </div>
                                        <div className="counter-container">
                                            <p className="font-detail text-confirm slide-paragraph">Bambini</p>
                                            <div className="counter-controls">
                                                <button type="button" className="counter-button" onClick={() => { const c = parseInt(children) || 0; if (c > 0) setChildren((c - 1).toString()); }} disabled={parseInt(children) <= 0} aria-label="Diminuisci"><span className="counter-icon">−</span></button>
                                                <span className="counter-value">{children || 0}</span>
                                                <button type="button" className="counter-button" onClick={() => { const c = parseInt(children) || 0; const t = parseInt(participants) || 1; if (c < t) setChildren((c + 1).toString()); }} disabled={parseInt(children) >= parseInt(participants)} aria-label="Aumenta"><span className="counter-icon">+</span></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="slide-buttons">
                                        <button type="button" onClick={prevSlide} className="slide-button prev-button">
                                        INDIETRO
                                        </button>
                                        <button type="button" onClick={nextSlide} disabled={!validateCurrentSlide()} className="slide-button next-button">
                                            AVANTI
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* NUOVA Slide 3: Nomi partecipanti (if attending) */}
                        {currentSlide === 2 && attendance === 'Si' && (
                            <div className="form-slide">
                                <h5 className='confirm font-detail'>
                                    Inserisci i nomi di tutti gli invitati
                                </h5>
                                <div className="slide-content">
                                    <div className="participant-names-group">
                                        {participantNames.map((participantName, index) => (
                                            <div key={index} className="participant-name-container">
                                                <label htmlFor={`participant-${index}`} className="font-detail participant-label">
                                                    {index === 0 ? 'Tu:' : `Invitato ${index + 1}:`}
                                                </label>
                                                <input
                                                    id={`participant-${index}`}
                                                    type="text"
                                                    placeholder={index === 0 ? name || "Il tuo nome" : "Nome e cognome"}
                                                    value={participantName}
                                                    onChange={(e) => handleParticipantNameChange(index, e.target.value)}
                                                    className="participant-name-input"
                                                    disabled={index === 0} // Il primo nome è già inserito nella slide precedente
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <div className="slide-buttons">
                                        <button type="button" onClick={prevSlide} className="slide-button prev-button">
                                        INDIETRO
                                        </button>
                                        <button type="button" onClick={nextSlide} disabled={!validateCurrentSlide()} className="slide-button next-button">
                                            AVANTI
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Slide 4: Menu Preferences (if attending) - CON SISTEMA TAB */}
                        {currentSlide === 3 && attendance === 'Si' && (
                            <div className="form-slide">
                                <h5 className='confirm font-detail'>
                                    Preferenze Menù
                                </h5>
                                <div className="slide-content">
                                    <p className="font-detail text-confirm slide-paragraph">Seleziona il menù per ogni persona:</p>
                                    <p className="recommended-text">La scelta degli sposi è il Menù Pesce ✨</p>
                                    
                                    {/* Tab Navigation */}
                                    <div className="participant-tabs">
                                        <div className="tab-navigation">
                                            {participantNames.map((participantName, index) => {
                                                const isVisited = visitedParticipants.includes(index);
                                                const isAccessible = isVisited || (index === Math.max(...visitedParticipants) + 1 && index < parseInt(participants));
                                                const isCompleted = participantMenuChoices[index] && ['pesce', 'carne', 'vegetariano'].includes(participantMenuChoices[index]);
                                                
                                                return (
                                                    <button
                                                        key={index}
                                                        type="button"
                                                        className={`tab-button 
                                                            ${activeParticipantTab === index ? 'active' : ''} 
                                                            ${isCompleted ? 'completed' : ''} 
                                                            ${isVisited ? 'visited' : ''} 
                                                            ${!isAccessible ? 'disabled' : ''}`}
                                                        onClick={() => handleTabClick(index)}
                                                        disabled={!isAccessible}
                                                    >
                                                        <span className="tab-name">
                                                            {participantName || `Invitato ${index + 1}`}
                                                        </span>
                                                        {isCompleted && (
                                                            <span className="tab-indicator">✓</span>
                                                        )}
                                                        {isVisited && !isCompleted && (
                                                            <span className="tab-indicator" style={{color: '#666'}}>•</span>
                                                        )}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                        
                                        {/* Tab Content */}
                                        <div className="tab-content">
                                            <div className="participant-menu-container">
                                                <label className="font-detail participant-menu-label">
                                                    <strong>{participantNames[activeParticipantTab] || `Partecipante ${activeParticipantTab + 1}`}:</strong>
                                                </label>
                                                <div className="menu-options-container">
                                                    <div className="menu-option">
                                                        <input
                                                            type="radio"
                                                            id={`menu-pesce-${activeParticipantTab}`}
                                                            name={`menu-${activeParticipantTab}`}
                                                            value="pesce"
                                                            checked={participantMenuChoices[activeParticipantTab] === 'pesce'}
                                                            onChange={() => handleParticipantMenuChange(activeParticipantTab, 'pesce')}
                                                        />
                                                        <label htmlFor={`menu-pesce-${activeParticipantTab}`} className="font-detail menu-option-label">
                                                            Menù Pesce ✨
                                                        </label>
                                                    </div>
                                                    <div className="menu-option">
                                                        <input
                                                            type="radio"
                                                            id={`menu-carne-${activeParticipantTab}`}
                                                            name={`menu-${activeParticipantTab}`}
                                                            value="carne"
                                                            checked={participantMenuChoices[activeParticipantTab] === 'carne'}
                                                            onChange={() => handleParticipantMenuChange(activeParticipantTab, 'carne')}
                                                        />
                                                        <label htmlFor={`menu-carne-${activeParticipantTab}`} className="font-detail menu-option-label">
                                                            Menù Carne
                                                        </label>
                                                    </div>
                                                    <div className="menu-option">
                                                        <input
                                                            type="radio"
                                                            id={`menu-vegetariano-${activeParticipantTab}`}
                                                            name={`menu-${activeParticipantTab}`}
                                                            value="vegetariano"
                                                            checked={participantMenuChoices[activeParticipantTab] === 'vegetariano'}
                                                            onChange={() => handleParticipantMenuChange(activeParticipantTab, 'vegetariano')}
                                                        />
                                                        <label htmlFor={`menu-vegetariano-${activeParticipantTab}`} className="font-detail menu-option-label">
                                                            Menù Vegetariano
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Allergie nel stesso tab */}
                                            <div className="participant-allergy-section">
                                                <div className="participant-allergy-container">
                                                    <label htmlFor={`allergy-${activeParticipantTab}`} className="font-detail allergy-participant-label">
                                                        Indica eventuali allergie (se presenti):
                                                    </label>
                                                    <input
                                                        id={`allergy-${activeParticipantTab}`}
                                                        type="text"
                                                        placeholder="Nessuna allergia"
                                                        value={allergiesByParticipant[activeParticipantTab] || ''}
                                                        onChange={(e) => handleParticipantAllergyChange(activeParticipantTab, e.target.value)}
                                                        className="allergy-participant-input"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Tab Navigation Buttons */}
                                        <div className="tab-navigation-buttons">
                                            <button 
                                                type="button" 
                                                onClick={prevParticipantTab} 
                                                disabled={activeParticipantTab === 0}
                                                className="tab-nav-button prev-tab-button"
                                            >
                                                ← Precedente
                                            </button>
                                            <span className="tab-counter">
                                                {activeParticipantTab + 1} di {participantNames.length}
                                            </span>
                                            <button 
                                                type="button" 
                                                onClick={nextParticipantTab} 
                                                disabled={activeParticipantTab === participantNames.length - 1}
                                                className="tab-nav-button next-tab-button"
                                            >
                                                Successivo →
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="slide-buttons">
                                        <button type="button" onClick={prevSlide} className="slide-button prev-button">
                                        INDIETRO
                                        </button>
                                        <button type="button" onClick={nextSlide} disabled={!isAllParticipantDataComplete()} className="slide-button next-button">
                                            AVANTI
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Slide 5: Message (if attending) - CORRETTO: Slide 4 */}
                        {currentSlide === 4 && attendance === 'Si' && (
                            <div className="form-slide">
                                <h5 className='confirm font-detail'>
                                    Messaggio per gli sposi (Opzionale)
                                </h5>
                                <div className="slide-content">
                                    <p className="font-detail text-confirm slide-paragraph">Vuoi lasciarci un messaggio? (Es. domande, richieste, auguri...)</p>
                                    <textarea
                                        placeholder="Scrivi qui il tuo messaggio..."
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        rows={4}
                                        className="text-area-input"
                                    />
                                    <div className="slide-buttons">
                                        <button type="button" onClick={prevSlide} className="slide-button prev-button">
                                            INDIETRO
                                        </button>
                                        <button type="button" onClick={handleSubmit} className="slide-button submit-button" disabled={isSubmitting}>
                                            {isSubmitting ? 'INVIO...' : 'INVIA'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>      
    </section>
  );
};

export default Rsvp;
